import Vue from 'vue'
import Vuex from 'vuex'
import * as types from './mutation-types'

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

// initial state
const state = {
    snackbar: {
        active: false,
        text: '',
        type: ''
    }
};

// getters
const getters = {
    snackbar: state => state.snackbar,
};

// actions
const actions = {
    hideSnackbar({commit}) {
        commit(types.HIDE_SNACKBAR);
    },
    showSuccessSnackbar ({ commit}, message) {
        commit(types.HIDE_SNACKBAR);
        commit(types.SHOW_SNACKBAR, {message});
        setTimeout(function(){ commit(types.HIDE_SNACKBAR) }, 4000);
    }
};

// mutations
const mutations = {
    [types.SHOW_SNACKBAR] (state, {message}) {
        state.snackbar.active = true;
        state.snackbar.message = message;
        state.snackbar.type = 'success';
    },

    [types.HIDE_SNACKBAR] (state) {
        state.snackbar.active = false;
    }
};

export default new Vuex.Store({
    state,
    strict: debug,
    getters,
    actions,
    mutations
})
